import Common from '../../../../Common';

interface UpdateBody {
	sim_id: id
}

const SIM = class extends Common {
	update = (companyId: id, subscriptionId: id, body: UpdateBody) =>
		this.patch(`/company/${companyId}/selfservice/subscription/${subscriptionId}/sim`, body)
}

export default SIM
